import {Grid,Button,IconButton, Typography} from "@mui/material";
import React from "react";
import { useCallback,useEffect,useState } from "react";
import ValidationsRulesTable from "../validationsRulesTable/ValidationsRulesTable";
import DashboardNavbar from "../../components/dashboardNavbar/DashboardNavbar";
import ValidationTile from "../validationTile/ValidationTile";
import { getValidationTable,getUpdatedValidationTable } from "../../services/integrationService";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";


export function ValidationDivision() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "ValidationDivision"
  const CUR_COMPONENT_COMMON="commonPortal";
    const lob = localStorage.getItem('lob');
    const [validationData, setValidationData] = useState<any[]>([]);
    const [summary, setSummary] = useState<any>({});
    const [selectedPage, setSelectedPage] = useState<string>('Division');
    const handleBackClick = () => {
      window.history.back();
    };
   
    const handleSelectedPage = (page: string) => {
      setSelectedPage(page);
     
    };
    


   
    
    const fetchDivisionData = useCallback(async () => {
      if(lob){
        const data = await getValidationTable(selectedPage,lob);
        const validationData= data.data.rules;
        setValidationData(validationData);
        const {total,success,failure} = data.data.summary;
        const newSummary = {total,success,failure}
        setSummary(newSummary);
      }
         
         
      }, [selectedPage]);
      const handleSwitchToggle = async (rowData: any, isChecked: boolean) => {
      if(lob){
        const ruleId = rowData.id;
        const activeStatus = isChecked ? "active" : "inactive";
        const updatedData = await getUpdatedValidationTable(ruleId, activeStatus,selectedPage,lob);
        setValidationData(updatedData.data.rules);
        const { total, success, failure } = updatedData.data.summary;
        const newSummary = { total, success, failure };
        setSummary(newSummary);
      }
         
        
      };
   


      useEffect(()=>{
        fetchDivisionData()
        
      },[fetchDivisionData]);
  return (
    <>
    <DashboardNavbar selectedPage={selectedPage} onPageClick={handleSelectedPage}/>
    <div className="box-container">
      <div className="tile-container">
        <Grid sx={{display:"flex", justifyContent:"center", color:"red"}} container>
        
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <ValidationTile heading={translate(TranslationEnum.validation_division,"Total Rules")} count={summary.total} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <ValidationTile heading={translate(TranslationEnum.validation_division,"Success")} count={summary.success} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <ValidationTile heading={translate(TranslationEnum.validation_division,"Failure")} count={summary.failure} />
              </Grid>
              <Grid item xs={12} sx={{ position: "absolute", right: "70px", top: "220px", color: "white", backgroundColor: "#24c6b1" }}>
             <Button variant="contained" color="primary" onClick={handleBackClick} style={{ color: "white", backgroundColor: "#24c6b1", fontWeight:"bold" }}>
             {translate(TranslationEnum.common_portal,"BACK")}
             </Button>
             </Grid>

            
        
        </Grid>
        </div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <ValidationsRulesTable data={validationData} onSwitchToggle={handleSwitchToggle} selectedPage={selectedPage}/>
          </Grid>
          
        
        </Grid> 
         
     
    </div>
    </>
  );
}
